import React from "react"
import { StyleSheet, TextInput, View } from "react-native"
import { Button } from "react-native-elements"
import Icon from "react-native-vector-icons/Feather"

import Base from "../../base"

export default function TextField(props) {
  return (
    <View style={[styles.main, props.style]}>
      {props.leftIcon && (
        <Icon name={props.leftIcon} size={24} color={Base.colours.appRed} />
      )}
      <TextInput
        style={[styles.textfield]}
        onChangeText={props.onChangeText}
        value={props.value}
        placeholder={props.placeholder}
        clearButtonMode={props.clearButtonMode ?? "always"}
        placeholderTextColor={Base.colours.appGrey}
        keyboardType={props.keyboardType}
        onBlur={props.onBlur}
      />
      {props.rightButton && props.value?.length > 0 && (
        <Button
          type={"clear"}
          titleStyle={styles.rightButton}
          title={props.rightButton}
          onPress={props.rightButtonAction}
        />
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    paddingHorizontal: 12,
    flexDirection: "row",
    flex: 1,
    height: 48,
    minHeight: 48,
    maxHeight: 48,
    borderRadius: 24,
    marginBottom: 15,
    borderColor: Base.colours.appSemiLightGrey,
    borderWidth: 1,
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
  },

  textfield: {
    flex: 1,
    height: 48,
    minHeight: 48,
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    paddingHorizontal: 10,
    fontFamily: Base.fonts.appRegular,
    fontSize: 16,
  },

  rightButton: {
    color: "black",
    fontSize: 14,
    fontFamily: Base.fonts.appRegular,
  },
})
